export default __webpack_public_path__ + "static/media/Print-489.4380a73d.jpg";